import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@fluentui/react/lib/Stack';
import {
  Body1,
  Title2,
} from '@fluentui/react-components';
import { useStyles } from './styles';

export const Lift = ({
  color,
  helpTopic,
  label,
  value,
}) => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const displayedValue = Number.isFinite(value)
    ? i18n.getString(_TL_('{{percentage}}%'), {
      percentage: Math.round(value * 100),
    })
    : i18n.getString(_TL_('--'));
  const learnMore = i18n.getString(_TL_('Click to learn more about'));

  return (
    <Stack>
      <div className={styles.label}>
        <Body1>{label}</Body1>
        <HelpButton
          aria-label={`${learnMore} ${label}`}
          topic={helpTopic}
        />
      </div>
      <Title2 style={{ color }}>
        {displayedValue}
      </Title2>
    </Stack>
  );
};

Lift.propTypes = {
  color: PropTypes.string.isRequired,
  helpTopic: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
